module.exports = __webpack_public_path__ + "media/images/icons/arrow_carousel-91de8dec3ae315d41e9e8ee83a495196.svg";